
import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OcProposalUploadComponent } from '../oc-proposal-upload/oc-proposal-upload.component';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-oc-shortlisting',
  standalone: true,
  imports: [CommonModule, OcProposalUploadComponent, FormsModule],
  template:`
  <div class="flex items-center justify-between bg-blue-600 text-white px-4 py-2 rounded-t-lg">
    <div class="flex items-center gap-4">

      <h2 class="text-2xl font-bold text-white">{{selectedStep | titlecase}}</h2>
      <div class="flex items-center mr-4 bg-white border border-gray-300 rounded px-2 py-1">
        <i class="pi pi-filter text-blue-600 mr-2"></i>
        <select class="text-blue-600 border-none p-2 rounded outline-none" (change)="onStepChange($event)" [(ngModel)]="selectedStep">
          <option value="" disabled>Select an option</option>
          <option selected value="screening">Screening</option>
          <option value="shortlisting">Shortlisting</option>
          <!-- <option value="final_selection">Final Selection</option> -->
        </select>
      </div>
    </div>
    <button type="button" class="bg-white text-blue-600 px-3 py-2 rounded hover:bg-blue-100 transition" (click)="historyBack()">
      <i class="pi pi-arrow-left mr-2"></i>
      Back
    </button>
  </div>
  
  <app-oc-proposal-upload [stepDetails]="'screening'"></app-oc-proposal-upload>`,
})
export class OcShortlistingComponent {
  @ViewChild(OcProposalUploadComponent) ocProposalUploadComponent?: OcProposalUploadComponent;
  constructor(private router: Router) {}
  historyBack(){
    this.router.navigate(['/scheme/idex'],{queryParams: {scheme_id: 46}});
  }
  selectedStep: string = 'screening';
  onStepChange(event: any){
    console.log(event, this.selectedStep);
  }
}
